import { Checkbox, Typography, useTheme } from '@mui/material'
import { INode, NodeType } from '../../../definitions/Nodes'
import { IAcceptedData } from '../../../definitions/NodesDescription'

interface P {
    acceptedData: IAcceptedData<NodeType>
    selectedNode: INode<NodeType>
    setSelected: (node: INode) => void
    disable: boolean
}

function NodeBoolEditor({ selectedNode, acceptedData, setSelected, disable }: P) {
    const theme = useTheme()
    const value = selectedNode.data[acceptedData.parameter] ?? false

    return (
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: theme.spacing(1) }}>
            <Typography>{acceptedData.parameter}: </Typography>
            <Checkbox
                disabled={disable}
                checked={value}
                sx={{ marginLeft: 1 }}
                onChange={e => {
                    const checked = e.target.checked
                    setSelected({ ...selectedNode, data: { ...selectedNode.data, [acceptedData.parameter]: checked } })
                }}
            />
        </div>
    )
}

export default NodeBoolEditor
